// extracted by mini-css-extract-plugin
export default {"link":"FavoritesLink_link__w7rbz","link__img":"FavoritesLink_link__img__XHTeG","link__counter":"FavoritesLink_link__counter__Knlml"};